import toRulebookExportEnvelope from "@next-platform/client-common-core/rulebook/editor/toRulebookExportEnvelope";
import type { RulebookDefinition } from "@next-platform/packages-ts-types";

/** Download the rulebook as a compact `rulebook/v1-draft` JSON file named `<id>.rulebook.json`. */
export default function downloadRulebookExport({ definition }: { definition: RulebookDefinition }): void {
  const envelope = toRulebookExportEnvelope(definition);
  const blob = new Blob([JSON.stringify(envelope, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = definition.id + ".rulebook.json";
  anchor.click();
  URL.revokeObjectURL(url);
}
